import {RootState} from '../index';
import {HubblGroupDTO, HubblBreakDTO, WebappHubbl} from '../../models';
import {BreakKey} from 'hubbl-shared';

// Helper functions to check hubbl types
const isHubblGroup = (hubbl: WebappHubbl): hubbl is HubblGroupDTO => {
  return 'type' in hubbl && hubbl.type === 'group';
};

const isBreak = (hubbl: WebappHubbl): hubbl is HubblBreakDTO => {
  return BreakKey.UserCreator in hubbl;
};

// Pending hubbles selectors
export const getPendingHubblesLoading = (state: RootState) =>
  state.hubbl.pendingHubbles.loading;
export const getPendingHubblesHasLoaded = (state: RootState) =>
  state.hubbl.pendingHubbles.hasLoaded;

// Scheduled hubbles selectors
export const getScheduledHubblesLoading = (state: RootState) =>
  state.hubbl.scheduledHubbles.loading;
export const getScheduledHubblesHasLoaded = (state: RootState) =>
  state.hubbl.scheduledHubbles.hasLoaded;

// Creation flow selectors
export const getCreationLoading = (state: RootState) =>
  state.hubbl.creation.loading;
export const getCreationError = (state: RootState) =>
  state.hubbl.creation.error;

// Connect creation selectors
export const getConnectCreation = (state: RootState) =>
  state.hubbl.creation.connect;

// Group creation selectors
export const getGroupCreation = (state: RootState) =>
  state.hubbl.creation.group;

// Categorized hubbles
export const getPendingHubblGroups = (state: RootState) => {
  return state.hubbl.pendingHubbles.hubbles.filter(isHubblGroup);
};

export const getPendingBreaks = (state: RootState) => {
  return state.hubbl.pendingHubbles.hubbles.filter(isBreak);
};

export const getScheduledHubblGroups = (state: RootState) => {
  return state.hubbl.scheduledHubbles.hubbles.filter(isHubblGroup);
};

export const getScheduledBreaks = (state: RootState) => {
  return state.hubbl.scheduledHubbles.hubbles.filter(isBreak);
};

export const HubblSelector = {
  // Pending hubbles
  getPendingHubblesLoading,
  getPendingHubblesHasLoaded,

  // Scheduled hubbles
  getScheduledHubblesLoading,
  getScheduledHubblesHasLoaded,

  // Creation flow
  getCreationLoading,
  getCreationError,

  // Connect creation
  getConnectCreation,

  // Group creation
  getGroupCreation,

  // Categorized
  getPendingHubblGroups,
  getPendingBreaks,
  getScheduledHubblGroups,
  getScheduledBreaks,
};
